(ns common.schema.entities.system-config
  "System-controlled, non-tenant configuration entries.

   Each row is one keyed entry (`:system-config/key`). The config-reload marker
   is the first such entry: a bump of `:system-config/generation` signals every
   peer to reload configuration from its own S3 key. `:system-config/last-error`
   holds the most recent reload failure as a single human-readable string
   (generation, host, S3 key and message) so a failed rollout is debuggable."
  (:require [common.schema.schema-utils :as su]))

(def ^:private system-opts
  {:default-field-visibility :not-in-use-blocked
   :authorization            su/access-system-system
   :system-semantics         su/system-controlled-optional-field-semantics})

(def schema
  (vec (concat
        (su/keyword-field :system-config/key "Config key" nil system-opts)
        (su/long-field :system-config/generation "Reload generation" system-opts)
        (su/text-multiline-field :system-config/last-error "Last reload error" system-opts))))
